import React from "react";
import Carrossel from "../../components/Carrossel";
import Homecards from "../../components/Homecards";
import Homenumeros from "../../components/Homenumeros";

const index = (props) => {
  return (
    <>
      <Carrossel />
      <Homecards />
      <Homenumeros />
    </>
  );
};

export default index;